import { Select } from '../../input';
import { Error } from '../../error';

export const ProxyInput = ({ params, onChange, errors }) => (
  <>
    <Select
      label="Proxy"
      noEmpty
      value={params.proxy}
      onChange={(val) => {
        console.log('proxy change', val);
        onChange('proxy', val);
      }}
      style={{ width: 120 }}
      choices={[
        ['none', 'No proxy (default)'],
        ['auto', 'Automatically pick proxy'],
        ['datacenter', 'Datacenter proxy ($0.50/GB)'],
        ['residential_cdp', 'Residential proxy (block assets) ($8/GB)'],
        ['residential_cdp_assets', 'Residential proxy (load assets) ($8.50/GB)'],
      ]}
    />
    <Error message={errors?.proxy} />
  </>
);
